/**
 * Which onboarding the logged-in user still has to run (PREC-3719).
 * Mirrors the API's EOnboardingVariant, which derives it once from the user
 * plus the workspace state — see `useOnboardingVariant`.
 */
export enum EOnboardingVariant {
	/** Self-signup first user — the full wizard including checkout (V1). */
	FULL = "FULL",
	/** First user of a workspace nobody set up — the same wizard, no checkout (V2). */
	FULL_NO_CHECKOUT = "FULL_NO_CHECKOUT",
	/** Joining a workspace that is set up — LinkedIn profile, then the setup guide (V3). */
	SLIM = "SLIM",
	/** Onboarding is done — nothing left to run. */
	NONE = "NONE",
}
